import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import test1 from "./Advanceautomation.svg"
import test2 from "./Legwisestoploss.svg"
import test3 from "./Strategybuilding.svg"
import test4 from "./Efficientbacktesting.svg"
import test5 from "./Optionsimulator.svg"
import test6 from "./Gettrades.svg"

import "./TradingStrategies.css";
const data = [
  { id: 1, img: test1, title: "Advance automation tools  to automate your trading", classunq: "Advanceautomation"},
  { id: 2, img: test2, title: "Legwise stoploss and target" , classunq: "Legwisestoploss"},
  { id: 3, img: test3, title: "Strategy building wizard to select multiple strategies", classunq: "Strategybuilding" },
  { id: 4, img: test4, title: "Efficient backtesting mechanism to remove errors", classunq: "Efficientbacktesting" },
  { id: 5, img: test5, title: "Option simulator for manual backtesting", classunq: "Optionsimulator" },
  { id: 6, img: test6, title: "Get trades executed @ 10rs/order only", classunq: "Gettrades" },
];
function TradingStrategies() {
  return (
    <>
      <section className="TradingStrategies_section">
        <h2>Automate and Backtest your<br></br>
        <span>Trading Strategies</span></h2>
        <div className="container">
          <div className="TradingStrategies_grid"><div className="row">
            {/* <img src={test} alt="test"/> */}
            {data.map((data, i) => {
                return (
                    <div key={i} className="col-md-4 col-sm-6">
                    <div className={`TradingStrategies_grouppanel ${data.classunq}`}>
                    <div className="TradingStrategies_panel text-center">
                    <div className="TradingStrategies_img">
                    <img src={data.img} alt="img" className="img-fluid" />
                    </div>
                      <h3>{data.title}</h3>
                    </div>
                    </div>
                    </div>
                );
            })
            }
            
              </div>
              </div>
        </div>
      </section>
    </>
  );
}
export default TradingStrategies;
